import Index from '@/components/stocks/index'

export default {
  name: 'stocks',
  path: 'stocks',
  redirect: '/stocks/index',
  meta: { auth: { statuses: ['inventoryDataApproved'] } },
  component: {
    render (c) { return c('router-view') }
  },
  children: [
    {
      path: 'index',
      meta: { auth: { statuses: ['inventoryDataApproved'] } },
      component: Index
    }
  ]
}
